import type { KeyboardEvent } from "react";
import { EditorSection } from "@/components/ListingFields/EditorSectionHeader";
import { TitleField, titleFieldCopy } from "@/components/ListingFields/TitleField";

const LISTING_TYPE = "service" as const;

export interface ServiceTitleEditorProps {
  /** Field error for the title input, or undefined when valid. */
  error?: string;
  /** Called with the new value on every field change. */
  onChange: (value: string) => void;
  /** Key handler; the container uses it to save on Enter. */
  onKeyDown?: (event: KeyboardEvent) => void;
  /** Current value of the title field. */
  value: string;
}

export function ServiceTitleEditor({ error, onChange, onKeyDown, value }: ServiceTitleEditorProps) {
  return (
    <EditorSection {...titleFieldCopy(LISTING_TYPE)}>
      <TitleField error={error} listingType={LISTING_TYPE} onChange={onChange} onKeyDown={onKeyDown} value={value} />
    </EditorSection>
  );
}
